import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import selectHelper from '../../../Helpers/selectHelper';
import UserService from '../../../Services/userService';

export default class VoidedPaymentsAdminSearchParams extends SearchParamsBase {
  initialize() {
    this.View = 'Voided Payments';
    this.AsSassieAsgnId = '';
    this.IeExportPaymentId = '';
    this.IeStatusCode = '';
    this.IePaymentType = '';
    this.Method = '';
    this.SelectedOfficeIds = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.AssignmentType = '';
    this.EvaluatorNameOrId = '';
    this.EvaluatorEmail = '';
    this.ClientNameOrId = '';
    this.ProjectNameOrId = '';
    this.IeTypeCode = '';
    this.SelectedAssignmentCountryCodes = [];
    this.SelectedPaymentOffices = [];
    this.SelectedAssignmentStatuses = [];
    this.CreatedBy = '';
    this.EmptyPayment = '';
    this.IeId = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'IeId', label: 'Pay ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'EvaluatorNameOrId', label: 'Evaluator Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'EvaluatorEmail', label: 'Evaluator Email', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedAssignmentCountryCodes',
      label: 'Country',
      className: 'col-6',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedPaymentOffices',
      label: 'Payment Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'ProjectNameOrId', label: 'Project Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'IeTypeCode',
      label: 'Type',
      className: 'col-2',
      type: InputTypesEnum.EvaluatorPaymentTypeLookupItemSelect,
    },
    { fieldName: 'EmptyPayment', label: 'Empty Payment', className: 'col-2', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'IeStatusCode',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.EvaluatorPaymentStatusLookupItemSelect,
      showCondition: (searchItem) => searchItem.Type !== 'pending_approval',
    },
    {
      fieldName: 'SelectedAssignmentStatus',
      label: 'Assignment Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: VoidedPaymentsAdminSearchParams.getStatusValues(),
    },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-4', type: InputTypesEnum.UserSelect },
  ];

  static getStatusValues() {
    return [
      { label: '', value: '', disabled: false },
      { label: 'Created', value: '0', disabled: false },
      { label: 'New', value: '1', disabled: false },
      { label: 'Incomplete', value: '2', disabled: false },
      { label: 'Completed', value: '3', disabled: false },
      { label: 'Collaboration Shop', value: '4', disabled: false },
      { label: 'Excluded', value: '5', disabled: false },
      { label: 'Hold A', value: '6', disabled: false },
      { label: 'Hold B', value: '7', disabled: false },
      { label: 'Reviewed', value: '8', disabled: false },
      { label: 'Finalized', value: '9', disabled: false },
      { label: 'Emailed', value: '10', disabled: false },
      { label: 'Client Finalized', value: '12', disabled: false },
      { label: 'Locked', value: '15', disabled: false },
      { label: 'Deleted in Apollo', value: '23', disabled: false },
    ];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'VoidedPaymentsAdminSearchParams';
}
